import { render, staticRenderFns } from "./email-message.vue?vue&type=template&id=ed5ab7f4&"
import script from "./email-message.vue?vue&type=script&lang=js&"
export * from "./email-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports